// Vendors
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Event Handlers
import { ErrorHandlers } from '../handlers/error.handlers';
// Types
import { ErrorComponentType } from '../types/error.component.type';

const useErrorHook = (onTryAgainClick: ErrorComponentType['onTryAgainClick']): void => {
  const { formatMessage } = useIntl();

  const { setMainButtonConfiguration } = useLayoutContextConsumerHook();

  const { handleSetupErrorLayoutButtonConfiguration } = ErrorHandlers({
    formatMessage,
    setMainButtonConfiguration,
    onTryAgainClick,
  });

  useEffect(() => {
    handleSetupErrorLayoutButtonConfiguration();
  }, []);
};

export { useErrorHook };
